import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { OPERATORS_FOR_CONDITION } from 'src/app/constants/products/products-list-actions';
import { AttributeModel, ConditionOperators, ReferenceParams } from 'src/app/models';
import { convertSizeModel } from 'src/app/models/convertSize.model';
import { ApiProductsService, DatetimeService, LanguageService, NotificationService, PermissionService } from 'src/app/services';
import { ApiBasicService } from 'src/app/services/api-basic.service';
import { ApiUserOrgRolesService } from 'src/app/services/api-user-org-roles.service';

@Component({
  selector: 'app-conditions-filter',
  templateUrl: './conditions-filter.component.html',
  styleUrls: ['./conditions-filter.component.css']
})
export class ConditionsFilterComponent implements OnInit {

  subscriptions: Subscription = new Subscription();
  title: string;
  component: string;
  language: string;
  attributes: AttributeModel[] = [];
  operators: ConditionOperators[][] = [];
  selectedOperatorsForCondition: string = 'AND';
  splitPattern: any[] = [];
  currentRoute: string = '';
  operatorsForCondition = OPERATORS_FOR_CONDITION;
  isDate: boolean[] = [];
  placement = 'bottom';
  settingVue: boolean;
  filterDataParams: any;
  sizeTg: boolean;
  checkEdit: boolean;
  disableValue: boolean[] = [];
  references: any[] = [];
  valueFieldType: string[] = ['input'];
  convertedSizeValue: number = 0;
  dayDate: any;
  minDate: any = Date.now;
  accessToAllProducts: boolean;



  convertSize: convertSizeModel[] = [
    {
      value: 'Кб'
    },
    {
      value: 'Мб'
    },
    {
      value: 'Гб',
    }
  ];

  fileAttributes: AttributeModel[] = [
    {
      id: 'name',
      name: 'Наименование'
    },
    {
      id: 'binding_value',
      name: 'Штрих-код'
    },
    {
      id: 'extension',
      name: 'Формат'
    },
    // {
    //   id: 'size',
    //   name: 'Размер'
    // },
    {
      id: 'create_date',
      name: 'Дата создания'
    }
  ];

  fileOperators: ConditionOperators[] = [
    {
      id: 'SIMILAR TO',
      name: 'Содержит'
    },
    {
      id: 'NOT SIMILAR TO',
      name: 'Не содержит'
    },
    {
      id: 'IN',
      name: 'Равно'
    },
    {
      id: 'NOT IN',
      name: 'Не равно'
    }
  ]

  fileDateOperators: ConditionOperators[] = [
    {
      id: '>=',
      name: 'Больше'
    },
    {
      id: '<=',
      name: 'Меньше'
    },
    {
      id: 'IN',
      name: 'Равно'
    },
    {
      id: 'Note IN',
      name: 'Не равно'
    }
  ]

  form: UntypedFormGroup = this.fb.group({
    filters: this.fb.array([])
  });


  @Input() set filterData(val) {

    this.component = val;
  }

  @Output() applyFormData = new EventEmitter();
  @Output() resetFormData = new EventEmitter();
  @Output() hiddenFilter = new EventEmitter();



  constructor(
    private fb: UntypedFormBuilder,
    private apiBasic: ApiBasicService,
    public permissionAccess: PermissionService,
    private datetimeService: DatetimeService,
    private languageService: LanguageService,
    private translate: TranslateService,
    private apiProducts: ApiProductsService,
    private notification: NotificationService,
    private apiUserOrgService: ApiUserOrgRolesService,
    private router: Router
  ) { }

  /**
   * 
   */
  ngOnInit(): void {

    this.currentRoute = this.router.url;


    if (this.currentRoute == '/settings') {

      this.settingVue = true;

    };

    this.getAttributes();

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    )

    // слушаем изменения для заполнения фильтра в редактировании роли
    this.subscriptions.add(

      this.apiUserOrgService.listenerFilterProductsData().subscribe((val) => {

        if (val) {

          this.getAttributes();
          this.checkEdit = true;

          console.log("VALUE: ", val);
        
          setTimeout(() => {
            this.selectedOperatorsForCondition = val.condition
            val.filter != null ? this.setFormData(val.filter) : (this.addFilterFields(), this.accessToAllProducts = true);
          }, 1000);

        }
      })
    );


    setTimeout(() => {

      if (!this.checkEdit) {

        this.addFilterFields();
      }
    }, 800);

    this.dayDate = Date();

  }

  /**
   * 
   */
  ngOnDestroy() {

    this.subscriptions.unsubscribe();
  }


  /**
   * 
   * 
   */
  addFilterFields(): void {

    let control = this.form.controls.filters as UntypedFormArray;
    control.push(this.initFilterField(control.length));

    this.valueFieldType[control.length] = 'input';

    this.onListenerAttribute(control.length - 1);

    // if (this.component == 'products') {
    this.onListenerOperators(control.length - 1);
    // }

  }

  /**
  * 
  * 
  */
  initFilterField(index: number): any {

    // Проверка на компонент и установка значения переменной this.operators()(список операторов сравнения)
    // this.component == 'files' ? this.operators[index] = this.fileOperators : this.getOperators(index);

    // if (this.component == 'files') {
    this.operators[index] = [];
    // }

    return this.fb.group({
      attribute_id: [null, Validators.required],
      operator: [null, Validators.required],
      values: [null, Validators.required],
      sizeType: ['Кб']
    });

  }


  /**
   * 
   * @param formulaData 
   */
  setFormData(filterData) {

    if (filterData != null) {

      filterData.forEach((element, index) => {

        this.addFormulaFieldsWithdata(element, index);

      });
    }
  }


  /**
   * 
   * @param formulaData 
   * @param index 
   */
  addFormulaFieldsWithdata(formulaData: any, index: number): void {

    let control = this.form.controls.filters as UntypedFormArray;

    control.push(this.setFormulaData(formulaData, index));

    this.onListenerAttribute(index);

    this.onListenerOperators(index);

    this.disableValue[index] = formulaData.operator == "!=''" || formulaData.operator == "'=''" ? false : true;

    control.updateValueAndValidity();
  }


  /**
   * 
   * @param formulaData 
   * @param index 
   * @returns 
   */
  setFormulaData(formulaData: any, index: number) {

    this.getAttrObject(formulaData.attribute_id);
    this.getProductOperators(index, this.getAttrObject(formulaData.attribute_id));


    return this.fb.group({
      attribute_id: [this.getAttrObject(formulaData.attribute_id)],
      operator: [formulaData.operator],
      values: [formulaData.values],
      sizeType: [null]
    });

  }

  /**
   * 
   */
  onClose() {

    this.hiddenFilter.emit(false)

  }


  /**
   * 
   * @param attrId 
   */
  getAttrObject(attrId) {

    return this.attributes.find(val => val.id == attrId);
  }

  /**
  * 
  * @param i number
  */
  removeFilterField(i: number): void {

    let control = this.form.controls.filters as UntypedFormArray;
    control.removeAt(i);

    control.controls.forEach((val, i) => {

      this.checkTypes(val.value.attribute_id.id, i);

    });
  }


  /**
   * 
   * @param id 
   * @param i 
   */
  checkTypes(id: string, i: number) {

    console.log("VAL: ", id);

    if (id == 'create_date') {

      this.valueFieldType[i] = 'date';

    } else if (id == 'size') {

      this.valueFieldType[i] = 'size';

    } else if (id == 'extension' || id == 'create_user_id' || id == 'attribute_id') {

      this.valueFieldType[i] = 'combobox';

    } else {

      this.valueFieldType[i] = 'input';
    }

  }


  /**
   * 
   * @param index 
   */
  onAttributeSubsription(index: number) {

    if (index > -1) {

      this.subscriptions.add(
        this.form.get(['filters', index, 'attribute_id']).valueChanges.subscribe(value => {

          if (value) {

            this.getAttributes(index);
          }
        })
      );
    }
  }

  /**
   * 
   */
  applyFilterData() {

    for (let f of this.form.value.filters) {

      f.attribute_id = typeof (f.attribute_id) == 'object' ? f.attribute_id.id : f.attribute_id;

      if (this.checkAttributeId(f.attribute_id)) {

        f.values = [this.datetimeService.convertDateForDB(f.values)];

      }

      if (typeof (f.values) === 'string') {

        f.values = [f.values];

      }

      if (f.attribute_id == 'size') {

        f.values = [String(this.convertSizeValue(f.sizeType, f.values))];

      }

      delete f.sizeType;

    }

    this.applyFormData.emit({ form: this.form.value, operatorForContion: this.selectedOperatorsForCondition });

    if (this.currentRoute == '/settings') {

      this.notification.show('success', 'Данные успешно сохранены!');

    }

  }

  /**
  * 
  */
  resetFilterData() {

    let control = this.form.controls.filters as UntypedFormArray;
    control.controls.splice(0, control.length);

    this.addFilterFields();

    this.resetFormData.emit(true);

  }

  /**
   * 
   */
  setToDedault() {

    let control = this.form.controls.filters as UntypedFormArray;
    control.controls.splice(0, control.length);

    this.addFilterFields();

    this.applyFormData.emit({ form: this.form.value, operatorForContion: this.selectedOperatorsForCondition });

    this.notification.show('success', 'Данные успешно сохранены!');

  }

  /**
  * 
  * @param index 
  */
  getAttributes(index: number = 0): void {

    let searchValue: string = '';

    let params: ReferenceParams = {
      ref_name: this.component == 'products' ? 'attributes_prod_list' : 'columns_files',
      filter: {
        name: searchValue,
        type: ['INPUT', 'TEXTAREA']
      }
    }

    this.subscriptions.add(
      this.apiBasic.getReferences(params, params.ref_name).subscribe((response: any) => {
        console.log("ATTRS_LIST: ", response);

        if (response != null) {

          this.attributes = response.result;

        }
      })
    );
  }

  /**
   * 
   */
  onListenerAttribute(index: number) {

    this.subscriptions.add(

      this.form.get(['filters', index, 'attribute_id']).valueChanges.subscribe(val => {

        this.form.get(['filters', index, 'operator']).setValue(null);

        if (val && this.component == 'files') {

          //смена паттерна для поля "значение"
          val.id == 'barcode' ? this.splitPattern[index] = new RegExp('[\n\\s+$,;]') : this.splitPattern[index] = null;

          this.checkTypes(val.id, index);

          this.getFileOperators(index, val.id);
          this.form.get(['filters', index, 'values']).setValue(null);
        }

        if (val && this.component == 'products') {

          //смена паттерна для поля "значение"
          val.name == 'Штрих-код' ? this.splitPattern[index] = new RegExp('[\n\\s+$,;]') : this.splitPattern[index] = null;

          this.getProductOperators(index, val);

          this.accessToAllProducts = false;
        }
      })
    );
  }

  /**
  * 
  * @param index 
  * @param operators 
  */
  onListenerOperators(index: number) {

    this.form.get(['filters', index, 'operator']).valueChanges.subscribe(listenedOperatorId => {

      this.form.get(['filters', index, 'values']).setValue(null);

      if (this.operators[index] != null) {

        let operatorObjectData = this.operators[index].find(opId => opId.id == listenedOperatorId);

        if (operatorObjectData != null && operatorObjectData != undefined) {

          if (operatorObjectData.enabled) {

            this.form.get(['filters', index, 'values']).setValidators(Validators.required);
            this.form.get(['filters', index, 'values']).updateValueAndValidity();

          } else {

            this.form.get(['filters', index, 'values']).setValidators(null);
            this.form.get(['filters', index, 'values']).updateValueAndValidity();
          }

          this.disableValue[index] = operatorObjectData.enabled;

        }
      }



    });
  }

  /**
  * 
  * @param index 
  * @param operators 
  */
  convertSizeValue(type: string, value: number): number {


    if (type == 'Кб') {

      return value = value * 1024;

    } else if (type == 'Мб') {

      return value = value * 1024 * 1024;

    } else if (type == 'Гб') {

      return value = value * 1024 * 1024 * 1024;
    }


  }


  /**
   * 
   * @param index 
   * @param attr 
   */
  getProductOperators(index, attr) {

    this.references[index] = null;

    let obj = {
      id: attr.id,
      attributeType: attr.attribute_type,
      attrPresetType: attr.attr_preset_type
    }

    this.subscriptions.add(
      this.apiProducts.getProductOperators(obj).subscribe((response: any) => {
        console.log("OPERATORS DATA: ", response);

        if (response != null && response.result != null) {

          this.operators[index] = response.result.operators;


          response.result.references ? (this.references[index] = response.result.references, this.valueFieldType[index] = 'combobox') : this.valueFieldType[index] = 'input'

          // if (response.result.references) {

          //   this.references[index] = response.result.references;

          //   this.valueFieldType[index] = 'combobox'

          // }

        }
      })
    );

  }

  /**
   * 
   * @param index 
   * @param attr_id 
   */
  getFileOperators(index: number, attr_id?: string): void {

    this.references[index] = null;

    let params: ReferenceParams = {
      // ref_name: 'filter_conditions_operators',
      ref_name: 'operators_files',
      filter: {
        attribute_id: attr_id
      }
    }

    this.subscriptions.add(
      this.apiBasic.getReferences(params, params.ref_name).subscribe((response: any) => {
        console.log("OPERATORS DATA: ", response);


        if (response != null && response.result != null) {

          this.operators[index] = response.result.operators;


          if (response.result.references) {

            this.references[index] = response.result.references;

          }

        }
      })
    );

  }



  /**
   * 
   * @param attribute_id 
   * @returns 
   */
  checkAttributeId(attribute_id: string): boolean {

    if (attribute_id == 'create_date') {

      return true;

    } else {

      return false;
    }
  }

}

